import { routes } from '@routes';
import { getOrganizationHomePath } from './getOrganizationHomePath';

type TParams = {
  isAuthenticated: boolean;
  organizationSlug?: string;
  email?: string | null;
};

export const getInvitationExitPath = ({ isAuthenticated, organizationSlug, email }: TParams): string => {
  if (isAuthenticated) {
    return getOrganizationHomePath(organizationSlug);
  }

  const trimmedEmail = email?.trim();

  return trimmedEmail ? `${routes.signin.make()}?email=${encodeURIComponent(trimmedEmail)}` : routes.signin.make();
};
